import * as React from 'react';
import { StyleSheet, Text } from 'react-native';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
const QuantityInputField = ({ color, style, value }) => {
    const colors = useColors();
    return (<Text style={[styles.number, style, { color: color ?? colors.text.whiteOnColor }]} numberOfLines={1} adjustsFontSizeToFit>
      {value}
    </Text>);
};
const styles = StyleSheet.create({
    number: {
        fontFamily: 'Nunito',
        fontWeight: '800',
        fontSize: rem(64),
        marginHorizontal: rem(20),
    },
});
export default QuantityInputField;
